import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Layout from "../../components/Layout";

const Categories = () => {
  const { t } = useTranslation("products");

  const categories = [
    {
      id: "electronics",
      name: "Electronics",
      image: "https://images.unsplash.com/photo-1498049860654-af1a5c5668ba",
      count: 120,
    },
    {
      id: "clothing",
      name: "Clothing",
      image: "https://images.unsplash.com/photo-1445205170230-053b83016050",
      count: 350,
    },
    {
      id: "home",
      name: "Home & Garden",
      image: "https://images.unsplash.com/photo-1484101403633-562f891dc89a",
      count: 200,
    },
    {
      id: "sports",
      name: "Sports",
      image: "https://images.unsplash.com/photo-1461896836934-ffe607ba8211",
      count: 85,
    },
    {
      id: "beauty",
      name: "Beauty",
      image: "https://images.unsplash.com/photo-1596462502278-27bfdd403348",
      count: 150,
    },
    {
      id: "books",
      name: "Books",
      image: "https://images.unsplash.com/photo-1495446815901-a7297e633e8d",
      count: 500,
    },
  ];

  return (
    <Layout title={t("categories") || "Categories"}>
      <h1 className="text-h1 mb-8 text-center">
        {t("shop_by_category") || "Shop by Category"}
      </h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {categories.map((category) => (
          <Link
            key={category.id}
            to={`/products?category=${category.id}`}
            className="group relative overflow-hidden rounded-lg shadow-md aspect-video hover:shadow-xl transition-shadow"
          >
            <img
              src={`${category.image}?auto=format&fit=crop&w=800&q=80`}
              alt={t(`category_${category.id}`) || category.name}
              className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-black bg-opacity-40 group-hover:bg-opacity-30 transition-all flex flex-col items-center justify-center text-white">
              <h3 className="text-h2 text-white">
                {t(`category_${category.id}`) || category.name}
              </h3>
              <span className="mt-2 text-body-sm bg-white/20 px-3 py-1 rounded-full backdrop-blur-sm">
                {category.count} {t("items") || "Items"}
              </span>
            </div>
          </Link>
        ))}
      </div>
    </Layout>
  );
};

export default Categories;
